import { SERVER_ROUTES } from "../../enums/Enums";
import * as axiosActions from "../../managers/Axios/AxiosActions";
import { trackException } from "../Azure/ApplicationInsightsActions";

//Add Car
export const addCar = (carOperationsEntity) => {
  return new Promise((resolve, reject) => {
    var requestBody = carOperationsEntity;

    axiosActions
      .POST(SERVER_ROUTES.ADD_CAR, requestBody, true, true)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - addCar()",
          error
        );
        reject(error);
      });
  });
};

//Delete Car
export const deleteCar = (carOperationsEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = carOperationsEntity;

    axiosActions
      .DELETE(SERVER_ROUTES.DELETE_CAR, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - deleteCar()",
          error
        );
        reject(error);
      });
  });
};

//Upadte Car
export const updateCar = (carOperationsEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = carOperationsEntity;

    axiosActions
      .PUT(SERVER_ROUTES.UPDATE_CAR, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - updateCar()",
          error
        );
        reject(error);
      });
  });
};

// Get Car Status
export const getCarStatus = (tokenValue, siteId, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var queryParams =
    "?tokenValue=" + tokenValue + "&siteId=" + siteId;

    axiosActions
      .GET(SERVER_ROUTES.CAR_STATUS, queryParams, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - getCarStatus()",
          error
        );
        reject(error);
      });
  });
};

// Is valid car details 
export const isValidCarDetails = (car, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = car;

    axiosActions
      .POST(SERVER_ROUTES.CAR_IS_VALID, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException("ActionsService.js - createUser()", error);
        reject(error);
      });
  });
};
